<template>
  <Base :base-id="'lb-advanced'" :base-class="'filter-modal'">
    <template #header>
      <h4 class="modal-title">進階篩選</h4>
      <a href="#" class="r-lightbox__close" @click="closeModal" />
    </template>
    <template #body>
      <div class="sort-block mb-2">
        <h5 class="text-center">價格</h5>
        <VueSlider
          v-model="range"
          :min="min"
          :max="max"
          :width="250"
          :height="5"
          :dot-size="14"
          tooltip="always"
        />
        <div class="slider-label">
          <span>NT.{{ min }}</span>
          <span>NT.{{ max }}</span>
        </div>
      </div>
      <div class="sort-block mb-2">
        <h5 class="text-center">尺寸(可複選)</h5>
        <div class="sort-condition size-opts">
          <div v-for="size in modalData.Sizes" :key="size.Key" class="size-block">
            <div
              :class="toggleSize(size.Value)"
              class="item-size"
              @click.prevent="addSize(size.Value)"
            >
              {{ size.Key }}
            </div>
          </div>
        </div>
      </div>
    </template>
    <template #footer>
      <div class="row w-100">
        <div class="col">
          <a class="btn btn-bgray w-100 btn-sm" href="#" @click.prevent="clearCondition">清除</a>
        </div>
        <div class="col">
          <a class="btn btn-primary w-100 btn-sm" href="#" @click.prevent="goResult">確定</a>
        </div>
      </div>
    </template>
  </Base>
</template>

<script setup>
import { ref, watch, nextTick } from 'vue';
import { storeToRefs } from 'pinia';
import useAdvancedSort from '@global/composable/shop/useAdvancedSort';
import VueSlider from 'vue-3-slider-component';

import useModalStore from '@global/stores/useModalStore';

import Base from '@global/components/common/modal/Base.vue';

const modalStore = useModalStore();
const { closeModal } = modalStore;
const { modalData } = storeToRefs(modalStore);

const { min, max, range, clearCondition, addSize, toggleSize, goResult } = useAdvancedSort({
  condition: modalData.value,
});
</script>
